/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Drawer, DrawerHeader
} from '@one-thd/sui-atomic-components';
import { extend } from '@thd-nucleus/data-sources';
import { triggerAnalytics } from './helpers';
import {
  DELIVERY_ZIP_OVERLAY,
  SHOPPING_IN_LINK
} from './analytics';
import { DeliveryZipcodeForm } from './DeliveryZipcodeForm';
import { DeliveryZipcodeButton } from './DeliveryZipcodeButton';

export const DeliveryZipcodeDrawer = ({
  openThroughProp,
  customActionButtonRenderFunction,
  onCloseZipCodeDrawer,
  onUpdate,
  projectId,
  assortmentZipCode,
  assortmentZipId,
  preferredStore
}) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    if (onCloseZipCodeDrawer) {
      onCloseZipCodeDrawer();
    }
    setOpen(false);
  };

  const handleSubmitSuccess = () => {
    handleClose();
  };

  useEffect(() => {
    if (open || openThroughProp) {
      triggerAnalytics(DELIVERY_ZIP_OVERLAY, {});
    }
    if (open) {
      triggerAnalytics(SHOPPING_IN_LINK, { link: 'zip code' });
    }
  }, [open, openThroughProp]);

  return (
    <>
      { customActionButtonRenderFunction && (
        customActionButtonRenderFunction({
          onClick: () => setOpen(true),
        })
      )}
      { !customActionButtonRenderFunction && (
        <DeliveryZipcodeButton
          assortmentZipCode={assortmentZipCode}
          onClick={() => setOpen(true)}
        />
      )}
      <Drawer
        data-testid="delivery-zipcode--projects-drawer"
        open={open || openThroughProp}
        onClose={handleClose}
      >
        <DrawerHeader onClose={handleClose} title="Update Delivery Zip" />
        <DeliveryZipcodeForm
          projectId={projectId}
          assortmentZipCode={assortmentZipCode}
          assortmentZipId={assortmentZipId}
          preferredStore={preferredStore}
          onUpdate={onUpdate}
          onSubmitSuccess={handleSubmitSuccess}
        />
      </Drawer>
    </>
  );
};

DeliveryZipcodeDrawer.displayName = 'DeliveryZipcodeDrawer';
DeliveryZipcodeDrawer.propTypes = {
  projectId: PropTypes.string,
  assortmentZipCode: PropTypes.string,
  assortmentZipId: PropTypes.string,
  preferredStore: PropTypes.string,
  onCloseZipCodeDrawer: PropTypes.func,
  onUpdate: PropTypes.func,
  customActionButtonRenderFunction: PropTypes.func,
  openThroughProp: PropTypes.bool
};

DeliveryZipcodeDrawer.defaultProps = {
  onCloseZipCodeDrawer: () => {},
  assortmentZipId: '',
  onUpdate: () => {},
  customActionButtonRenderFunction: null,
  projectId: '',
  assortmentZipCode: '',
  preferredStore: '',
  openThroughProp: false
};

DeliveryZipcodeDrawer.dataModel = extend(
  DeliveryZipcodeForm
);
